module.exports = __webpack_public_path__ + "img/driver.c8244830.svg";